// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "map" + "." + "908828318dc37836c22a" + ".min.css";
};